import { ObjectTypes } from '@fi-shared/types/object-type';

export function areaDeleteIsItemToUnShare(item): boolean {
    return (
        item.ObjectType === ObjectTypes.MediaBank ||
        item.ObjectType === ObjectTypes.Tag ||
        item.ObjectType === ObjectTypes.SiteMap ||
        item.ObjectType === ObjectTypes.Template ||
        item.ObjectType === ObjectTypes.CheckListTemplate ||
        item.ObjectType === ObjectTypes.Forum
    );
}
